import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { IApiResponse, IFeeDto, IFilterPaginationDto } from '../models';

@Injectable()
export class FeeService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getFeeList(model: IFilterPaginationDto): Observable<IFeeDto[]> {
    return this.post(`admin/fee/list`, model);
  }

  public changeFeeStatus(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/fee/${id}`, null);
  }

  public addFee(model: IFeeDto): Observable<IApiResponse<boolean>> {
    return this.post(`admin/fee/save`, model);
  }
}
